import React from "react";
import { useTheme, lighten } from "@mui/material/styles";
import { darken, Grid, Typography } from "@mui/material";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EmployeePresenceAndLeavesSummaryDTO } from "../../../../models/employee-presence-and-leaves-summary/employee-presence-and-leaves-summary-dto";
import { PresenceAndLeavesSummaryDTO } from "../../../../models/presence-and-leaves-summary/presence-and-leaves-summary-dto";
import { computeMonthName } from "../../../../utils/time-utils";
const MyTeamPresenceAndLeavesFooter = ({
  customSummary,
  loading,
}: {
  customSummary?: PresenceAndLeavesSummaryDTO;
  loading: boolean;
}) => {
  const theme = useTheme();
  return (
    <>
      {Number(customSummary?.extraHours) > 0 && !loading ? (
        <Grid>
          <Grid style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <FontAwesomeIcon
              icon={faCircleExclamation}
              color={theme.palette.error.light}
            />
            <Typography
              color={theme.palette.error.light}
              variant="body2"
            >
              Extra hours
            </Typography>
          </Grid>
          <Grid
            style={{
              display: "flex",
              marginLeft: "20px",
            }}
          >
            <Typography
              variant="body2"
              color={darken(theme.palette.text.secondary, 0.1)}
            >
              {computeMonthName(new Date().getMonth())} :{" "}
            </Typography>
            <Typography
              variant="body2"
              color={theme.palette.error.light}
            >
              {customSummary?.extraHours}h
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
};
export default MyTeamPresenceAndLeavesFooter;
